export default "__VITE_ASSET__DW6TT632__"